import { wrapClientApiCall } from '../../../utils'

export const createReferral = ({ email }) =>
    wrapClientApiCall({
        actionRoot: 'CREATE_REFERRAL',
        method: 'POST',
        url: `api/consumer/create-referral`,
        body: JSON.stringify({ email }),
    })
